// extracted by mini-css-extract-plugin
export default {"main":"upload_main__Kuk3h","logo":"upload_logo__2hucP","inside_text":"upload_inside_text__b+lkI"};